<template>
  <div class="flex flex-col flex-1 lg:my-12 lg:max-w-md lg:pr-11 sections-nav" v-if="data && data.docs?.length && product">
    <div class="flex gap-2 items-center py-5 cursor-pointer mt-2 mb-2 lg:hidden border-b-2" @click="toggleMbMnDisplay">
      <strong>{{ currentSectionName }}</strong>
      <nv-icon>{{ mbMnDisplay ? 'expand-less' : 'expand-more' }}</nv-icon>
    </div>
    <div
      :class="{'flex mt-10': mbMnDisplay, 'hidden lg:flex mt-5 lg:mt-0': !mbMnDisplay}"
    >
      <nv-collapse :value="route.query.section">
        <nv-collapse-item
          v-for="(section, idx) in data?.docs"
          :key="section.id"
          :value="section.slug"
        >
          <div slot="header" class="nv-d-flex nv-align-items-center nv-justify-content-between">
            <span class="nv-d-flex">
              {{ section.name }}
            </span>
            <nv-icon>expand-more</nv-icon>
          </div>
          <ul slot="content" class="flex flex-col gap-3">
            <li
              v-for="article in section.articles"
              :key="article.id"
            >
              <nuxt-link :to="localePath(`/products/${customerType}/${product.slug}/kb/${article.slug}?section=${section.slug}`)" :class="{'selected': article.slug === route.params.article_slug}">
                {{ article.title }}
              </nuxt-link>
            </li>
          </ul>
        </nv-collapse-item>
      </nv-collapse> 
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useProductStore } from '~/store/product';

// ---------------------------------------
// Props
// ---------------------------------------

// ---------------------------------------
// Hooks
// ---------------------------------------
const productStore = useProductStore();
const localePath = useLocalePath();
const { localeProperties, locale } = useI18n(); 
const mbMnDisplay = ref(false);

const route = useRoute();

const currentSectionName = computed(() => {
  const query_slug = route.query.section;

  return data.value?.docs.find((section) => section.slug === query_slug)?.name;
});

const customerType = computed(() => route.params.customerType);

const { product } = storeToRefs(productStore);

const {status, error, data } = await useFetch(`/api/support/${localeProperties.value.region}/sections?language_code=${localeProperties.value.language}&product=${product.value?.slug}`,
  {
    key: `productsGridSupport:${localeProperties.value.code}:${localeProperties.value.language}`,
    lazy: true,
    immediate: true,
  }
);

// ---------------------------------------
// Methods
// ---------------------------------------

function toggleMbMnDisplay() {
  mbMnDisplay.value = !mbMnDisplay.value;
}
</script>

<style lang="scss" scoped>
/*
* Mixes
*/
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/mixins/_breakpoints';

.articles-list {
  color: inherit;
  list-style: none;

  a {
    color: inherit;
  }
}

.topics-list {
  column-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  row-gap: 24px;

  li {
    background: var(--nv-theme);
    border-radius: 8px;
    padding: 16px;

    &:hover {
      box-shadow: 0 0 4px 4px rgba(0, 99, 180, 0.12);
      cursor: pointer;
    }

    img {
      height: 40px;
      margin-right: 8px;
      width: 40px;
    }
  }
}

nv-collapse {
  width: 100%;
}

.sections-nav {
  @media (screen(lg)) {
    border-right: 1px solid var(--nv-theme-border);
  }

  a {
    color: inherit;

    &:hover {
      color: var(--nv-theme-primary-dark);
      text-decoration: underline;
      cursor: pointer;
    }

    &.selected {
      color: var(--nv-theme-primary);
    }
  };
}
</style>
